/**
 * Map / history constants
 */
const NOT_RUNNING_YET = -1
const STOPPED = 0
const RUNNING = 1
const PAUSED = 2
const SHOW_FULL_ROUTE = 3
const HIDE_FULL_ROUTE = 4
const SHOW_ROUTE_POINTS = 5
const HIDE_ROUTE_POINTS = 6

export default {
    NOT_RUNNING_YET,
    STOPPED,
    RUNNING,
    PAUSED,
    SHOW_FULL_ROUTE,
    HIDE_FULL_ROUTE,
    SHOW_ROUTE_POINTS,
    HIDE_ROUTE_POINTS
}